(() => {
  const placeSizeChart = () => {
    const chart = document.querySelector('#MainContent .ks-container-app-block .ks-chart-container');
    const sizeGroup = Array.from(document.querySelectorAll('#MainContent .swatch-single')).find((group) => group.querySelector('input[name="Size"]'));
    const label = sizeGroup?.querySelector('.swatch-label-container');
    if (!chart || !label || label.contains(chart)) return;
    label.appendChild(chart);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeSizeChart, { once: true });
  } else {
    placeSizeChart();
  }
  const observer = new MutationObserver(placeSizeChart);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
